import { Component, Inject, LOCALE_ID } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { MeterProvider } from '../../providers/meter/meter';
import { ToastProvider } from '../../providers/toast/toast';
import { UtilService } from '../../services/util';
import moment from 'moment';
import { formatNumber } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { PermissionCheckPipe } from '../../pipes/permission-check/permission-check';
import { LoginProvider } from '../../providers/login/login';

@IonicPage()
@Component({
  selector: 'page-meter-reading',
  templateUrl: 'meter-reading.html',
})
export class MeterReadingPage {

	pageNo = 1;
	data: any ;
  enableLoad = true;
  showData = false;
  showBalance = false;
  lastSyncTime = null;
  liveReading = false;
  selRegistrationLogin  : any;
  permissions:any;


  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private translate: TranslateService,
  	public meterProvider: MeterProvider, 
    private toast: ToastProvider,
    private login: LoginProvider,
    private util: UtilService) {
      login.getUserDetails().then(val => {
        this.permissions = val.permissions;
      });
      this.selRegistrationLogin = localStorage.getItem('signup_login')

      if(this.selRegistrationLogin){
        this.showData = true;
        this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
      }
      else{
  	meterProvider.getReadings(this.pageNo).then(val=> {
  		if(val.status == "success"){
        this.data =[];
        this.data = this.setReadingData(val.data)
        console.log(this.data)
  		}else{
  			toast.presentToast(val.message);
      }
      this.showData = true;
  	}).catch(e => {
      console.log("--------------");
      console.log(e);
      this.util.showNoInternet();
      this.showData=true;
    });
  }
  }
  setReadingData(data){
      let lst = null;
      let res = [];
      data.forEach(reading => {
        if(reading.updated_at){
          lst = lst ? (moment(lst) > moment(reading.updated_at) ? lst : reading.updated_at) : reading.updated_at;
        }
        if(reading.balance){
          this.showBalance = true;
        }
        if(reading.sync_id){
          console.log(reading.sync_id)
          this.liveReading = true
        }
        reading.dg = formatNumber(reading.dg,'en-US',"1.1-1")
        reading.grid = formatNumber(reading.grid,'en-US',"1.1-1")
        reading.time = moment(reading.date_time).format('D MMM YY, h:m A')
        res.push(reading)
        console.log(reading)
      });
      this.lastSyncTime = lst ? moment(lst).format('D MMM YY, h:m A') : lst
      console.log(this.lastSyncTime)
      console.log(res)
      return res
  }
  doInfinite(infiniteScroll) {
    this.pageNo++;
    this.meterProvider.getReadings(this.pageNo).then(val=> {
  		if(val.status == "success"){
        if(this.data){
          if(val.metadata.count/val.metadata.perPage < this.pageNo){
            this.enableLoad = false;
          }
          // val.data.forEach(element => {
          //   this.data.push(element);
          // });
          this.data = [ ...this.data, ...this.setReadingData(val.data)];
        }
  		}else{
  			this.toast.presentToast(val.message);
      }
      infiniteScroll.complete();      
  	});
  }

  doRefresh(refresher) {
    if(this.selRegistrationLogin){
      setTimeout(() => {
        this.showData = true;
        refresher.complete() 
        },2000)
    }
    else{
    this.pageNo = 1;
    this.meterProvider.getReadings(this.pageNo).then(val=> {
  		if(val.status == "success"){
        // this.data = val.data;
        this.data = this.setReadingData(val.data);
        this.enableLoad = true;
  		}else{
  			this.toast.presentToast(val.message);
      }
      refresher.complete();
    });
  }
  }
  getAmount(amount: number){
    return Math.abs(amount);
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad MeterReadingPage');
  }
  showPopup(title, message){
    this.util.showPopup(title, message );
  }
  checkBookPermission(mod,type){
  
    let perPipe = new PermissionCheckPipe();
if (perPipe.transform(this.permissions, mod, type)) {
return true
}
else{
  return false
}
 }
}



// WEBPACK FOOTER //
// ./src/pages/meter-reading/meter-reading.ts